<!--<div [hidden]="!loading">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>-->
<div id="http-loader" [hidden]="!loading">
  <div class="loader-bg">
    <div class="sk-line-material" [class.colored]="!backgroundColor" *ngIf="spinner === Spinkit.skLine">
      <div class="sk-child sk-bounce1" [style.background-color]='backgroundColor'></div>
    </div>
  </div>
</div>
